import React from "react";
import logo from "./../../../../assets/newIcons/Lucky.png";

const Modal = ({ title, content, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* <div className="modal-backdrop fixed inset-0 bg-black opacity-5"></div> */}
      <div className="modal-container w-80 rounded-xl shadow-custom">
        <div className="flex bg-gradient-to-r from-gradient_start to-gradient_end rounded-t-xl justify-start items-center modal-header text-xl text-white">
          <img className="w-14 py-2 ml-6 mr-2" src={logo} alt="logo" />
          {title.toUpperCase()}
        </div>
        <div className="bg-white/[0.8] rounded-b-xl">
          <div className="flex justify-center modal-body p-3">
            <p className="p-1 font-myanmarSansPro">{content}</p>
          </div>
          <div className="modal-footer pb-3 flex justify-end pr-5">
            <button
              className="bg-gradient-to-r from-gradient_start to-gradient_end text-white font-bold font-dangrek py-2 px-8 rounded-full"
              onClick={onClose}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
